export const STATES = {
  confirmNotActiveWorkOrder: { tagPostFix: 'confirm-not-work-order' },
  physicalIssueQuestion: { tagPostFix: 'physical-issue-question' },
  physicalIssueForm: { tagPostFix: 'physical-issue-form' },
  binLevelQuestion: { tagPostFix: 'level-question' },
  binLevelSelect: { tagPostFix: 'level-select' },
  binLevelFormHeight: { tagPostFix: 'level-form-height' },
  binLevelFormWeight: { tagPostFix: 'level-form-weight' },
  dimensionsQuestion: { tagPostFix: 'dimensions-question' },
  dimensionsForm: { tagPostFix: 'dimensions-form' },
  commentsForm: { tagPostFix: 'comments-form' },
  thankYou: { tagPostFix: 'thank-you' },
};

export const START_STATE = 'physicalIssueQuestion';
export const WARN_START_STATE = 'confirmNotActiveWorkOrder';
export const MILL_BIN_START_STATE = 'commentsForm';

export const TRANSITION_NAMES = {
  cancel: 'cancel',
  back: 'back',
  submit: 'submit',
  next: 'next',
  yes: 'yes',
  no: 'no',
};

export const STATE_TRANSITIONS = {
  confirmNotActiveWorkOrder: {
    yes: 'physicalIssueQuestion',
  },
  physicalIssueQuestion: {
    yes: 'physicalIssueForm',
    no: 'binLevelQuestion',
  },
  physicalIssueForm: {
    submit: 'thankYou',
  },
  binLevelQuestion: {
    yes: 'dimensionsQuestion',
    no: 'binLevelSelect',
  },
  binLevelSelect: {
    next: 'binLevelFormHeight',
  },
  binLevelFormHeight: {
    next: 'binLevelFormWeight',
  },
  binLevelFormWeight: {
    next: 'dimensionsQuestion',
  },
  dimensionsQuestion: {
    yes: 'commentsForm',
    no: 'dimensionsForm',
  },
  dimensionsForm: {
    next: 'commentsForm',
  },
  commentsForm: {
    submit: 'thankYou',
  },
};
